module.exports = __webpack_public_path__ + "static/media/ag.354453de.svg";